import { take, put, call, fork } from "redux-saga/effects"
import { authRequest } from "src/engine/modules/authRequest"
import env from "src/env"
import get from "lodash/get"
import { updateEvent } from "src/engine/modules/calendar/actions/creators"
import { showToast } from "@infotech/uikit-toasts"
import { UPDATE_CALENDAR_EVENT_STATUS } from "../actions/types"

import {
  requestTransitionListSuccess,
  requestTransitionListError,
} from "../actions/creators"

const { REACT_APP_API_URL } = env

function* request(action) {
  const { event, newStatusCode } = action.config
  try {
    // Запрос на изменение статуса
    yield call(authRequest, {
      url: `${REACT_APP_API_URL}/events/status`,
      method: `post`,
      data: {
        eventUuid: event,
        statusCode: newStatusCode,
      },
    })
    // Запрос события, для обновления его статуса на календаре
    const eventData = yield call(authRequest, {
      url: `${REACT_APP_API_URL}/events/${event}`,
    })
    // Непосредственное обновление события на календаре
    yield put(updateEvent(eventData.data))
    // Запрашиваем новый список переходов для статусов
    const response = yield call(authRequest, {
      url: `${REACT_APP_API_URL}/events/${event}/transitions`,
    })
    yield call(showToast, {
      type: `success`,
      message: `Статус успешно изменен.`,
      hideIn: 5,
    })
    yield put(requestTransitionListSuccess(response))
  } catch (error) {
    yield put(requestTransitionListError(error))
    yield call(showToast, {
      type: `error`,
      message: get(error, `response.data.exception`),
      hideIn: 5,
    })
  }
}

export default function* updateSaga() {
  while (true) {
    const action = yield take(UPDATE_CALENDAR_EVENT_STATUS)
    yield fork(request, action)
  }
}
